<div class="row">
  <div class="col-sm-12">
    <h5 [innerHTML]="description"></h5>
  </div>
  <div class="col-sm-12 myIframe" *ngIf="pdfUrl">
    <iframe [src]="pdfUrl"
            type="application/pdf"></iframe>
  </div>
</div>
